import React, { useMemo } from "react";

export default function FixedIntervals(props) {
  const { setToInterval, isSomedayDisabled } = props;

  const _intervals = useMemo(intervals, [isSomedayDisabled]);

  function intervals() {
    return (
      <div className="fixed-intervals">
        <button className="today" onClick={setToInterval}>
          Today
        </button>
        <button onClick={setToInterval}>6w</button>
        <button onClick={setToInterval}>3m</button>
        <button onClick={setToInterval}>6m</button>
        <button onClick={setToInterval}>1y</button>
        <button
          disabled={isSomedayDisabled}
          className="yellow"
          onClick={setToInterval}
        >
          Someday
        </button>
      </div>
    );
  }

  return _intervals;
}
